<script setup lang="ts">
const isOutdatedBrowser = computed(() => false);

/*
const isOutdatedBrowser = computed(() => {
	const cssProps = {
		"accent-color": "blue",
		inset: "0",
	};
	const supportsCSS = Object.keys(cssProps).every((key) =>
		CSS.supports(key, cssProps[key as keyof typeof cssProps]),
	);

	const supportsJS = Boolean([].at);
	return !supportsJS || !supportsCSS;
});
*/

const options = reactive({
	wrapper: {
		style: {
			background: "rgba(0, 0, 0, 0.7)",
		},
	},
});
</script>

<template>
	<browser-detect
		v-if="isOutdatedBrowser"
		:options="options"
	></browser-detect>
</template>

<style lang="scss" scoped></style>
